module.exports = __webpack_public_path__ + "static/img/u7.0855115.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u7.png
// module id = +d31
// module chunks = 19